export default __webpack_public_path__ + "static/media/header-home-mobile.16585077.png";